import { SravniNewsSharedEnumsMaterialType } from '../__generated__/news/Api';
import { TRubricType } from '../interfaces/news';

export const TAKE_MATERIALS = 6;
export const TAKE_AMP_MATERIALS = 15;
export const TAKE_MATERIALS_INITIAL = 12;
export const TAKE_NEWS_INITIAL = TAKE_MATERIALS_INITIAL;

export const TAKE_ADDITIONAL_READING_MOBILE = 2;
export const TAKE_ADDITIONAL_READING = 3;

export const URL_TYPES = {
  [SravniNewsSharedEnumsMaterialType.News]: 'novost',
  [SravniNewsSharedEnumsMaterialType.Article]: 'text',
  [SravniNewsSharedEnumsMaterialType.PrivateArticle]: 'text',
};

export const PRODUCT_RUBRIC_MAP: { [key: string]: TRubricType } = {
  strakhovanie: 'strahovki',
};

export const TAGS_MAX_LENGTH = 3;

export enum MATERIAL_TAG {
  GAMES = 'Игры',
  CALCS = 'Калькуляторы',
  TESTS = 'Тесты',
}

export enum FILTERS_NAMES {
  TEXT = 'text',
  TAG = 'tag',
}

export type FILTERS = {
  [FILTERS_NAMES.TEXT]?: string;
  [FILTERS_NAMES.TAG]?: string[];
};
